import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-xl" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = {
  key: 0,
  class: "w-100 d-flex"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border mx-auto",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "d-flex overflow-hidden mt-2" }
const _hoisted_12 = { class: "my-auto" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "gallery-grid mt-2" }
const _hoisted_16 = { class: "container-top-end addon" }
const _hoisted_17 = { class: "modal-footer" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Image = _resolveComponent("Image")!
  const _component_Checkbox = _resolveComponent("Checkbox")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    tabindex: "-1",
    id: _ctx.id
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t( 'editor.gallery' )), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.search,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                    class: "p-inputtext-sm"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currTags.filter(t => _ctx.selectedTags.includes(t[0])), (tag) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "badge mx-1 cursor-pointer bg-success",
                        key: tag[0],
                        onClick: ($event: any) => (_ctx.toggleTag(tag[0]))
                      }, _toDisplayString(tag[ 0 ]) + " ( " + _toDisplayString(tag[ 1 ]) + " ) ", 9, _hoisted_13))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currTags.filter(t => !_ctx.selectedTags.includes(t[0])), (tag) => {
                      return (_openBlock(), _createElementBlock("span", {
                        class: "badge mx-1 cursor-pointer bg-primary",
                        key: tag[0],
                        onClick: ($event: any) => (_ctx.toggleTag(tag[0]))
                      }, _toDisplayString(tag[ 0 ]) + " ( " + _toDisplayString(tag[ 1 ]) + " ) ", 9, _hoisted_14))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currImgs, (img) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "grid-element",
                      key: img.id
                    }, [
                      _createVNode(_component_Image, {
                        preview: true,
                        src: img.itemSrc,
                        alt: img.alt,
                        imageClass: "image-cover w-100 h-100",
                        class: "w-100 h-100"
                      }, null, 8, ["src", "alt"]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_Checkbox, {
                          value: img.id,
                          modelValue: _ctx.selectedImgIds,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedImgIds) = $event)),
                          onInput: _ctx.singleChoiceHandler
                        }, null, 8, ["value", "modelValue", "onInput"])
                      ])
                    ]))
                  }), 128))
                ])
              ], 64))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clean && _ctx.clean(...args))),
            "data-bs-dismiss": "modal"
          }, _toDisplayString(_ctx.$t( 'common.cancel' )), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.select && _ctx.select(...args))),
            "data-bs-dismiss": "modal",
            disabled: _ctx.selectedImgIds.length < 1 || !(_ctx.multiple || _ctx.selectedImgIds.length === 1)
          }, " (" + _toDisplayString(_ctx.selectedImgIds.length) + ") " + _toDisplayString(_ctx.$t( 'common.select' )), 9, _hoisted_18)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}